import OutstandingAccountSearchForm from '../../components/orders/outstanding-account-search-form';
import AbstractAsyncTablePage from '../abstract-async-table-page';
import Table from '../../components/shared/table';
import SearchForm from '../../model/search-form';
import InvoiceData from '../../model/invoice-data';
import { formatDate } from '../../helpers/utils';
import HTMLTemplateHelper from '../../helpers/html-template-helper';
import MessageHelper from '../../helpers/message-helper';
import FileDocumentData from '../../model/file-document-data';

export default class InvoicePage extends AbstractAsyncTablePage {
  protected readonly searchForm: SearchForm;
  protected readonly table: Table;
  protected readonly tableColumnDefinitions: DataTables.ColumnDefsSettings[] = [
    {
      targets: 0,
      data: 'id',
    },
    {
      targets: 1,
      data: (data: FileDocumentData, type: string): string | number => {
        if (data.submittedDate === null) {
          return 0;
        }
        if (type === 'sort') {
          return data.submittedDate;
        }
        return formatDate(new Date(data.submittedDate));
      },
    },
    {
      targets: 2,
      data: (data: InvoiceData): string => HTMLTemplateHelper.createLinkButton({
        buttonClass: '-clear -compact',
        href: `${window.ACC.config.encodedContextPath}/webreturns/outstandingaccount/print?token=${data.fileDownloadJwt}`,
        text: MessageHelper.getMessage('common.print'),
        textClass: 'sr-only',
        icon: 'fas fa-file-download',
      }).outerHTML,
      className: 'text-align-center',
    },
  ];

  constructor(body: JQuery) {
    super();
    this.searchForm = new OutstandingAccountSearchForm(body.find('.js-outstandingAccountForm') as JQuery<HTMLFormElement>);
    this.table = new Table(body.find('.js-table'), this.tableColumnDefinitions);
    this.bindAsyncData();
  }
}
